import type { FC } from "react";
import { Button, Label, RadioGroup, Radio } from "@design-lab/shared/ui";
import { Loader } from "lucide-react";
import type { Question } from "../../model/artist-instructions-types";

interface QuestionsListProps {
  questions: Question[];
  onSubmit: () => void;
  isLoading: boolean;
}

export const QuestionsList: FC<QuestionsListProps> = ({ questions, onSubmit, isLoading }) => {
  const hasUnansweredQuestions = questions.some(q => !q.answer);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm font-medium">
        Please answer the following questions to help us better understand your needs:
      </p>
      {questions.map((question, index) => (
        <div key={index} className="space-y-2">
          <Label data-testid={`question-${index}-label`} className="text-sm font-medium">
            {question.title}
          </Label>
          <RadioGroup
            value={question.answer || ""}
            onChange={value => {
              question.answer = value;
            }}
            isDisabled={isLoading}
          >
            {question.options.map((option, optionIndex) => (
              <div key={optionIndex} className="flex items-center space-x-2">
                <Radio
                  data-testid={`question-${index}-option-${optionIndex}-radio`}
                  value={option}
                  id={`q${index}-o${optionIndex}`}
                />
                <Label
                  data-testid={`question-${index}-option-${optionIndex}-label`}
                  htmlFor={`q${index}-o${optionIndex}`}
                  className="font-normal"
                >
                  {option}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>
      ))}
      <Button
        data-testid="submit-answers-button"
        onPress={onSubmit}
        isDisabled={hasUnansweredQuestions || isLoading}
        className="w-full"
      >
        {isLoading ? (
          <div className="flex items-center gap-2">
            <Loader size={20} className="animate-spin" />
            Processing...
          </div>
        ) : (
          "Submit Answers"
        )}
      </Button>
    </div>
  );
};
